import naturalCompare from 'string-natural-compare';

export const flatComparator = (a: any, b: any) => naturalCompare(a, b);
